import './player-section-skeleton.css';

export default function PlayerSectionSkeleton({ label = 'Loading section', rows = 3 }) {
  return <div className="player-section-skeleton" role="status" aria-label={label} aria-busy="true" data-testid="player-section-skeleton">
    {Array.from({ length: rows }, (_, index) => <div className="player-section-skeleton__row" key={index} aria-hidden="true">
      <span className="player-section-skeleton__icon" /><div><span /><span /></div>
    </div>)}
  </div>;
}
